// Pure date/calendar helpers, no Firebase imports — ported from school-site's
// src/data/calendarMath.ts. Kept dependency-free so it can also be used from
// a plain Node script (a future seed/import admin script) without pulling in
// the Firebase client SDK.

export function addDaysIso(dateIso, n) {
  const [y, m, d] = dateIso.split('-').map(Number);
  const dt = new Date(y, m - 1, d);
  dt.setDate(dt.getDate() + n);
  return `${dt.getFullYear()}-${String(dt.getMonth() + 1).padStart(2, '0')}-${String(dt.getDate()).padStart(2, '0')}`;
}

export function weekNumberForDate(weeks, dateIso) {
  for (let i = 0; i < weeks.length; i++) {
    if (dateIso >= weeks[i] && dateIso <= addDaysIso(weeks[i], 4)) return i + 1;
  }
  return 0;
}

// Mirrors quarterOf() from the original Day Board mockup: Q1 wks 1-9, Q2
// 10-17, Q3 18-27, Q4 28-36.
export function quarterForWeek(w) {
  if (w >= 1 && w <= 9) return 1;
  if (w >= 10 && w <= 17) return 2;
  if (w >= 18 && w <= 27) return 3;
  if (w >= 28 && w <= 36) return 4;
  return 0;
}

// Every instructional date across the year — 179 entries for the default
// Cedar Vale calendar (36 weeks x 5 days, minus Labor Day).
export function allInstructionalDates(calendar) {
  const out = [];
  for (const monday of calendar.weeks) {
    for (let i = 0; i < 5; i++) {
      const date = addDaysIso(monday, i);
      if (!calendar.holidays[date]) out.push(date);
    }
  }
  return out;
}

export function todayIso() {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
}

export function isoWeekdayNumber(dateIso) {
  const [y, m, d] = dateIso.split('-').map(Number);
  const jsDay = new Date(y, m - 1, d).getDay(); // 0=Sun..6=Sat
  return jsDay === 0 ? 7 : jsDay;
}

// Firestore rejects `undefined` field values — strip them before any write
// rather than remembering to do it at every call site.
export function stripUndefined(obj) {
  const out = {};
  for (const [k, v] of Object.entries(obj)) {
    if (v !== undefined) out[k] = v;
  }
  return out;
}
